import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NativeInteractiveContainerElement1pn7ly9a3ij8y as NativeInteractiveContainerElement } from '../InteractiveElement.commonHtml.mjs';
import {
  FloatingInfoHolder1eisb99cxddo9 as FloatingInfoHolder,
  FloatingInfoHolder$_get_preferredDirection_$ref_ex9o803a3n0i7iydqh3 as FloatingInfoHolder$_get_preferredDirection_$ref_ex9o80,
  FloatingInfoHolder$_set_preferredDirection_$ref_xuqxbg1g7bb804dwert as FloatingInfoHolder$_set_preferredDirection_$ref_xuqxbg,
} from './FloatingInfoHolder.js.mjs';
import { ClickableSemantic_getInstance29tidgppnw5x2 as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import {
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { menuDriverActionspd2q4q8dt14s as menuDriverActions } from './DriverOverrides.mjs';
import { plus2m1vv33moko5t as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Companion_instance3sky7m0l0l4tp as Companion_instance } from './Frame.commonHtml.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function MenuButton$_get_preferredDirection_$ref_wnuw33() {
  return constructCallableReference((p0) => p0.get_preferredDirection_hs930n_k$(), 1, 0, 90);
}
function MenuButton$_set_preferredDirection_$ref_aerfnf() {
  return constructCallableReference((p0, p1) => {
    p0.set_preferredDirection_gql2kx_k$(p1);
    return Unit_instance;
  }, 2, 0, 91);
}
var MenuButtonClass;
function MenuButton() {
  if (MenuButtonClass === VOID) {
    class $ extends NativeInteractiveContainerElement() {
      constructor(context) {
        super(context);
        this._openMenu_1 = null;
        this.floating_1 = new (FloatingInfoHolder())(this);
        this.set_themeChoice_py59um_k$(this.get_themeChoice_22tyn3_k$().plus_duvq05_k$(ClickableSemantic_getInstance()));
        this.native_1.tag_1 = 'button';
        this.native_1.classes_1.add_utx5q5_k$('kiteui-stack');
        this.native_1.classes_1.add_utx5q5_k$('clickable');
        this.native_1.setAttribute_j9pxft_k$('aria-haspopup', 'dialog');
        this.native_1.setAttribute_j9pxft_k$('aria-expanded', 'false');
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('click', (it) => {
            this.floating_1.open_fm36nu_k$();
            this.floating_1.block_337we5_k$();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.eventsBack_1['on' + 'click'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'click';
          this_0.eventsBack_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            this.floating_1.open_fm36nu_k$();
            this.floating_1.block_337we5_k$();
            return Unit_instance;
          };
        }
        var tmp0 = this.native_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name = 'mouseenter';
        var tmp0_safe_receiver_0 = tmp0.element_1;
        var tmp_2;
        if (tmp0_safe_receiver_0 == null) {
          tmp_2 = null;
        } else {
          tmp0_safe_receiver_0.addEventListener(name, (it) => {
            if (!this.requireClick_1) {
              this.floating_1.open_fm36nu_k$();
            }
            return Unit_instance;
          });
          tmp_2 = Unit_instance;
        }
        if (tmp_2 == null) {
          // Inline function 'kotlin.run' call
          var tmp_3 = tmp0.eventsBack_1['on' + name];
          var old_0 = (!(tmp_3 == null) ? typeof tmp_3 === 'function' : false) ? tmp_3 : null;
          var tmp_4 = 'on' + name;
          tmp0.eventsBack_1[tmp_4] = (it) => {
            var tmp0_safe_receiver = old_0;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!this.requireClick_1) {
              this.floating_1.open_fm36nu_k$();
            }
            return Unit_instance;
          };
        }
        this.requireClick_1 = false;
        var tmp_5 = this;
        var tmp0_0 = this.floating_1;
        var tmp_6 = KMutableProperty0();
        var tmp_7 = FloatingInfoHolder$_get_preferredDirection_$ref_ex9o80(tmp0_0);
        tmp_5.preferredDirection$delegate_1 = getPropertyCallableRef('preferredDirection', 0, tmp_6, tmp_7, FloatingInfoHolder$_set_preferredDirection_$ref_xuqxbg(tmp0_0));
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), menuDriverActions(this, this._openMenu_1));
      }
      nativeAddChild_hge4nv_k$(index, element) {
        super.nativeAddChild_hge4nv_k$(index, element);
        Companion_instance.internalAddChildStack_5el07d_k$(this, index, element);
      }
      set_preferredDirection_gql2kx_k$(_set____db54di) {
        var tmp0 = this.preferredDirection$delegate_1;
        var tmp = KMutableProperty1();
        var tmp_0 = MenuButton$_get_preferredDirection_$ref_wnuw33();
        // Inline function 'kotlin.setValue' call
        getPropertyCallableRef('preferredDirection', 1, tmp, tmp_0, MenuButton$_set_preferredDirection_$ref_aerfnf());
        tmp0.set(_set____db54di);
        return Unit_instance;
      }
      get_preferredDirection_hs930n_k$() {
        var tmp0 = this.preferredDirection$delegate_1;
        var tmp = KMutableProperty1();
        var tmp_0 = MenuButton$_get_preferredDirection_$ref_wnuw33();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('preferredDirection', 1, tmp, tmp_0, MenuButton$_set_preferredDirection_$ref_aerfnf());
        return tmp0.get();
      }
      opensMenu_gggyad_k$(createMenu) {
        this.floating_1.menuGenerator_1 = createMenu;
        var tmp = this;
        tmp._openMenu_1 = () => {
          this.floating_1.open_fm36nu_k$();
          this.floating_1.block_337we5_k$();
          return Unit_instance;
        };
      }
    }
    initMetadataForClass($, 'MenuButton');
    MenuButtonClass = $;
  }
  return MenuButtonClass;
}
//region block: exports
export {
  MenuButton as MenuButton27en4jjgdkozz,
};
//endregion

//# sourceMappingURL=MenuButton.commonHtml.mjs.map
